import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { safeNumericString } from 'app/infrastructure/data/sanitize';

export const selectorId = (id: string) =>
  (isDefinedIncludingZero(safeNumericString(id)) ? safeNumericString(id) : undefined) as number;
